import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/transaction-kinds/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const transactionKinds = {
  getAll: apiPathFunc(pathBase),
} as const;
